import { useKrakenMutation } from '@/components/GraphQLClient';
import { GuestJourneyEnum } from '@/types/generated/graphql/schema';

import { guestOneTimeAccessSchema } from '../validations';

import GuestOneTimeAccess from './GuestOneTimeAccess.graphql';

type GuestOneTimeAccessInput = {
  input: {
    journey: GuestJourneyEnum;
  };
};

export const useGuestOneTimeAccess = ({
  scopedToken,
}: {
  scopedToken: string;
}) => {
  return useKrakenMutation({
    mutation: (_: GuestOneTimeAccessInput) => GuestOneTimeAccess,
    validateFn(response) {
      return guestOneTimeAccessSchema.validate(response);
    },
    requestHeaders: {
      Authorization: scopedToken,
    },
    gcTime: 0,
  });
};
